import React, { useEffect } from "react";

export default function DisplayAd({
  adSlot = "5079384162",
  adFormat = "auto",
  fullWidthResponsive = true,
  style = { display: "block", minHeight: "100px" },
  className = ""
}) {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error("AdSense Error:", error);
    }
  }, []);

  return (
    <div className={className} style={{ overflow: "hidden" }}>
      <ins
        className="adsbygoogle"
        style={style}
        data-ad-client="ca-pub-8398267064923692"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive ? "true" : "false"}
      />
    </div>
  );
}